// extracted by css-extract-rspack-plugin
export default {"colorDefaultAlternate":"rgba(209, 209, 209, 1)","timelineContainer":"horizontal-timeline__timelineContainer___GrMph"};